import axios from "axios";
import Config from "../config"
import { useLoginStore } from '../stores/login';
// const store = useLoginStore();

export default class ApplianceService {
  constructor() {
    this.loginStore = null;
  }

  store() {
    if(!this.loginStore) { this.loginStore = useLoginStore(); };
    return this.loginStore;
  }

  fetchUnclaimAppliance(id) {
    const options = {
      headers: { 
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    }

    return axios
      .delete(
        Config.url("unclaim_device_admin").replace("{{deviceCode}}",id),
        options
      )
      .then(res => res.data);
  }

  fetchAppliances(limit = 10, offset = 0, filters = [], sortObject, selectStatus = []) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    }

    let bodyTosend = {
      "limit": limit,
      "offset": offset,
      "status": selectStatus
    }

    // if (filters.length > 0) {
      bodyTosend.filter_attributes = filters;
    // }

    if (sortObject?.order_attr !== "") {
      bodyTosend.order_attr = sortObject.order_attr;
      bodyTosend.asc_or_desc = sortObject.asc_or_desc;
    }

    return axios
      .post(
        Config.url("appliance"),
        bodyTosend,
        options
      )
      .then(res => res.data);
  }
  async fetchAppliance(id) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      },
      // params: {
      //   "tenant": this.store().getTenant,
      //   "country": "global"
      // },
    };
    let url = Config.url("appliance") + ((id != null) ? "/" + id : "");
    return axios
      .get(
        url,
        options
      )
      .then(res => res.data);
  }
  fetchFirmwareHistory(claimerEndUserCode, deviceCode) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    }

    return axios
      .get(
        Config.url("firmware_history").replace("{{deviceCode}}",deviceCode),
        options
      ).then(res => res.data );
  }

  async updateFirmware(appliance, confirmation, version) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      },
    };
    let bodyTosend = {
      // "tenant": this.store().getTenant,
      // "device_code": appliance.id,
      // "claimer_enduser_code": appliance.owner,
      // "country": "global",
      "operation": "FIRMWARE_UPGRADE",
      "parameters": {
        "firmwareVersion": version,
        "needUserConfirmation": confirmation
      }
    }

    return axios
      .post(
        Config.url("firmware_update").replace("{{deviceCode}}",appliance.id),
        bodyTosend,
        options
      ).then(res => { return res.data });
  }

  fetchMap() {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    }

    return axios
      .get(
        Config.url("map"),
        options
      )
      .then(res => res.data.items);
  }
  async fetchDdm(tenant, type, statuses) {

    //TODO bisogna gestire i vari DDM, prendendo dei dati che serviranno dagli status (che cambieranno in base al tenant:
    // smeg: prodType ??
    // smegcons: modello o che altro ??

    const options = { }

    return await axios
      .get(
        './ddms/' + tenant + '/ddm_' + type + '.json',
        options
      )
      .then(res => res.data);
  }
  async fetchTranslations(tenant) {

    //TODO bisogna gestire i vari DDM, prendendo dei dati che serviranno dagli status (che cambieranno in base al tenant:
    // smeg: prodType ??
    // smegcons: modello o che altro ??

    const options = { }

    return await axios
      .get(
        './ddms/' + tenant + '/translations.json',
        options
      )
      .then(res => res.data);
  }

  // updateDeviceTags(id, newTags) {
  //   const options = {
  //     headers: {
  //       ...Config.headers(this.store().getAccessToken), ...{}
  //     }
  //   }
  //   let bodyTosend = {
  //     "tenant": this.store().getTenant,
  //     "entity_id": id,
  //     "tags": newTags
  //   }
  //   return axios
  //     .post(
  //       Config.url("updateDeviceTags"),
  //       bodyTosend,
  //       options
  //     )
  //     .then(res => res)
  //     .catch(err => err);
  // }

  fetchVerboseAppliances(limit = 10, offset = 0, filters = []) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    }

    let startDate = null;
    let endDate = null;

    for(let i=0; i<filters.length; i++) {
      if(filters[i].key == "date") {
        let dates = filters[i].dformat.split(", ");
        startDate = dates[0];
        endDate = dates[1];
        break;
      }
    }

    let bodyTosend = {
      "limit": limit,
      "offset": offset,
      "startDate": startDate,
      "endDate": endDate
    }

    return axios
      .post(
        Config.url("verbose_appliances"),
        bodyTosend,
        options
      )
      .then(res => res.data);
  }
  fetchVerboseSingleAppliance(limit = 10, offset = 0, activationCode) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    }

    let bodyTosend = {
      "limit": limit,
      "offset": offset,
    }

    return axios
      .post(
        Config.url("verbose_appliances") + "/" + activationCode,
        bodyTosend,
        options
      )
      .then(res => res.data);
  }
}
